import { RawDraftContentState } from "draft-js";
import { ChatChannelName } from "../../../../channels/types";
import { toMarkdown as slackToMarkdown } from "./slack";
import { toMarkdown as teamsToMarkdown } from "./teams";

export const toMarkdown = (content: RawDraftContentState, channel: ChatChannelName): string =>
  channel === "slack" ? slackToMarkdown(content) : teamsToMarkdown(content);
